export const Facebook = (props) => {
  const { size = 16, onClick, verticalAlign, marginLeft, marginRight, top, color, className = '' } = props;
  return (
    <span onClick={onClick} className={`icon-wrap ${className}`} style={{ marginLeft, marginRight, top, color }}>
      <svg style={{ verticalAlign }} width={size} height={size} viewBox='0 0 10 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M6.64892 20H2.21557V10.5558H0V6.91641H2.21557V4.73321C2.21557 1.76634 3.4664 0 7.0204 0H9.97893V3.6394H8.13041C6.74651 3.6394 6.65447 4.1474 6.65447 5.09671L6.64892 6.91641H10L9.60745 10.5558H6.64892V20Z'
          fill='currentColor'
        />
      </svg>
    </span>
  );
};
